(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nox-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nox-hero-slider')) {
    class NoxHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.nox-slide')];
        this.dots = [...this.querySelectorAll('.nox-slider__dot')];
        this.index = 0;
        this.dots.forEach((dot) => dot.addEventListener('click', () => { this.go(Number(dot.dataset.index)); this.stop(); }));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const seconds = Number(this.dataset.interval) || 0;
        if (this.slides.length > 1 && seconds > 0 && !reduce && !window.Shopify?.designMode) {
          this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), seconds * 1000);
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('focusin', () => this.stop());
        }
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.findIndex((s) => s.contains(event.target));
          if (i >= 0) { this.go(i); this.stop(); }
        });
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      go(i) {
        this.index = i;
        this.slides.forEach((slide, n) => {
          const active = n === i;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, n) => dot.setAttribute('aria-current', String(n === i)));
      }
    }
    customElements.define('nox-hero-slider', NoxHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nox-media-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nox-autoplay')) {
    class NoxAutoplay extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.video.removeAttribute('controls');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          this.video.setAttribute('controls', '');
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.video.play().catch(() => this.video.setAttribute('controls', ''));
              } else {
                this.video.pause();
              }
            });
          },
          { threshold: 0.5 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
    customElements.define('nox-autoplay', NoxAutoplay);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nox-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nox-tabs')) {
    class NoxTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
            const next = (i + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
          if (panel) panel.hidden = !on;
        });
      }
    }
    customElements.define('nox-tabs', NoxTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nox-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nox-carousel')) {
    class NoxCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.buttons = [...this.querySelectorAll('.nox-carousel__btn')];
        if (!this.track) return;
        this.buttons.forEach((button) =>
          button.addEventListener('click', () => {
            const step = this.track.clientWidth * 0.9;
            this.track.scrollBy({ left: step * Number(button.dataset.dir), behavior: 'smooth' });
          })
        );
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.buttons[0]) this.buttons[0].disabled = this.track.scrollLeft <= 2;
          if (this.buttons[1]) this.buttons[1].disabled = this.track.scrollLeft >= max;
          const nav = this.querySelector('.nox-carousel__nav');
          if (nav) nav.hidden = max <= 0;
        };
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }
    }
    customElements.define('nox-carousel', NoxCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nox-wall-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nox-wall-guide')) {
    class NoxWallGuide extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('.nox-seg__btn')];
        this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button)));
        const active = this.buttons.find((b) => b.getAttribute('aria-pressed') === 'true') || this.buttons[0];
        if (active) this.select(active);
      }

      select(button) {
        this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        const w = Number(button.dataset.w);
        const h = Number(button.dataset.h);
        const total = Number(button.dataset.total) || w * 2 + 3;
        const sofa = Number(this.dataset.sofa) || 200;
        const frame = this.dataset.frame || '#1c1c1c';
        const gap = Math.max(1, total - w * 2);
        const x0 = 160 - total / 2;
        const y = 102 - h;
        const ns = 'http://www.w3.org/2000/svg';
        const rect = (x, yy, rw, rh, fill) => {
          const r = document.createElementNS(ns, 'rect');
          r.setAttribute('x', x);
          r.setAttribute('y', yy);
          r.setAttribute('width', rw);
          r.setAttribute('height', rh);
          r.setAttribute('fill', fill);
          return r;
        };
        const frames = this.querySelector('[data-frames]');
        frames.replaceChildren();
        for (let i = 0; i < 2; i++) {
          const x = x0 + i * (w + gap);
          const outer = rect(x, y, w, h, frame);
          outer.setAttribute('stroke', '#bdb6aa');
          outer.setAttribute('stroke-width', '0.3');
          frames.append(outer, rect(x + 1.6, y + 1.6, w - 3.2, h - 3.2, '#f3efe8'), rect(x + w * 0.22, y + h * 0.2, w * 0.56, h * 0.6, '#cfd5de'));
        }
        const sofaShape = this.querySelector('[data-sofa-shape]');
        const sx = 160 - sofa / 2;
        sofaShape.replaceChildren(
          rect(sx, 128, sofa, 40, '#cfc6b8'),
          rect(sx - 8, 120, 18, 48, '#cfc6b8'),
          rect(sx + sofa - 10, 120, 18, 48, '#cfc6b8'),
          rect(sx + 10, 112, sofa - 20, 22, '#d8d0c3')
        );
        const yy = y - 6;
        this.querySelector('[data-dim]').setAttribute(
          'd',
          `M${x0} ${yy}H${x0 + total}M${x0} ${yy - 2.5}v5M${x0 + total} ${yy - 2.5}v5`
        );
        const label = this.querySelector('[data-dim-text]');
        label.setAttribute('y', yy - 4);
        label.textContent = `${total} cm`;
        this.querySelector('[data-each-out]').textContent = button.dataset.each;
        this.querySelector('[data-total-out]').textContent = button.dataset.totalLabel;
      }
    }
    customElements.define('nox-wall-guide', NoxWallGuide);
  }

  } catch(e) { console.error(e); }
})();
})();
